import styled from 'styled-components';
import { colorGrey05 } from '../../css/colors';

export const Code = styled.pre`
  font-size: 10px;
  display: none;
`;

export const MapComponentContainer = styled.div`
  display: flex;
  position: relative;
  flex: 1 0 auto;
  max-width: 100%;

  &.loading * {
    pointer-events: none !important;
  }

  @media (max-width: 640px) {
    position: fixed;
    z-index: ${({ panelShowing }) => (panelShowing ? 100 : 'auto')};
    top: 55px;
    left: 0;
    bottom: 0;
    right: 0;
    flex: 0;
  }

  .leaflet-control-container {
    @media (max-width: 640px) {
      display: none;
    }
  }

  .MainMapContainer {
    position: relative;
    flex: 1;

    .ll-main-popup {
      min-width: 25rem;
    }
  }
`;


export const MapLayerPanelWrapper = styled.div`
  > div {
    z-index: auto;

    button {
      z-index: 30;
    }

    @media (max-width: 640px) {
      > div {
        background-color: #fff;
      }
    }
  }

  .ll-map-layer-panel-panel {
    z-index: 30;
  }

  .ll-map-mobile-panel-container {
    z-index: 100;

    .ll-map-mobile-panel-action-container {
      .ll-map-layer-panel-update-button:last-child {
        min-width: calc(50vw - 18px);
        margin-left: -20px;
      }
    }
  }
`;

export const FiltersContainerWrapper = styled.div`
  padding: 15px 15px 0;
  > div > div {
    z-index: 90;
  }

  .ll-map-mobile-panel-container {
    z-index: 100;

    input {
      min-width: 40px;
    }
  }
`;

export const RedoSearchButtonContainer = styled.div`
  button {
    z-index: 29;
    margin: 0 auto;
    ${({ show }) =>
      !show
        ? `
        display: none;
      `
        : ''};
  }
  bottom: 75px;
  position: absolute;
  width: 100%;
`;

export const LoadingContainer = styled.div`
  display: flex;
  width: 100%;
  z-index: 95;
  pointer-events: none;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const LoadingDrawer = styled.div`
  width: 25%;
  padding-top: 380px;
`;

export const LoadingMap = styled.div`
  width: 75%;
  background-color: rgba(255, 255, 255, 0.5);
`;

export const SkeletonContainer = styled.div`
  background-color: white;
  padding: 5px 20px;
`;
